import { Injectable } from '@angular/core';
const SECRET_KEY = 'secret_key';
import * as CryptoJS from 'crypto-js';
// var CryptoJS = require('crypto-js');
@Injectable({
    providedIn: 'root'
})
export class StorageService {
    constructor() {}
    encrypt(value) {
        const ciphertext = CryptoJS.AES.encrypt(JSON.stringify(value), SECRET_KEY).toString();
        return ciphertext;
    }

    decrypt(value) {
        const decryptedData = CryptoJS.AES.decrypt(value, SECRET_KEY).toString(CryptoJS.enc.Utf8);
        return JSON.parse(decryptedData);
    }

    encryptUTF8(value: any) {
        const keyTrans = CryptoJS.enc.Utf8.parse('8080808080808080');
        const ivTrans = CryptoJS.enc.Utf8.parse('8080808080808080');
        const encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(JSON.stringify(value)), keyTrans, {
            keySize: 128 / 8,
            iv: ivTrans,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });
        const modifiedformat = encrypted.toString().split('+').join('-');
        const encryptedFormat = modifiedformat.split('/').join('_');
        return encryptedFormat;
    }

    decryptUTF8(data: string) {
        // console.log(data)
        const encryptedFormat = data?.split('-').join('+');
        const modifiedformat = encryptedFormat?.split('_').join('/');
        if (modifiedformat) {
            const key = CryptoJS.enc.Utf8.parse('8080808080808080');
            const iv = CryptoJS.enc.Utf8.parse('8080808080808080');
            const decrypted = CryptoJS.AES.decrypt(modifiedformat, key, {
                keySize: 128 / 8,
                iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            });
            const decryptedValue = decrypted.toString(CryptoJS.enc.Utf8);
            return decryptedValue;
        } else {
            return '{}';
        }
    }
}
